module.exports = __webpack_public_path__ + "static/media/PrebookUserConfirm.610ea9a7.svg";